<template>
  <div class="contents">
    <div class="header">
      <div class="tab">
        <span
          v-permissson="'CKXX'"
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="changeType(0, 'CKXX')"
        >
          仓库信息
        </span>
        <span
          v-permissson="'TTXX'"
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="changeType(1, 'TTXX')"
        >
          抬头信息
        </span>
        <span
          v-permissson="'MT'"
          class="tabItem"
          :class="{ active: active === 2 }"
          @click="changeType(2, 'MT')"
        >
          码头
        </span>
        <span
          v-permissson="'CSHS'"
          class="tabItem"
          :class="{ active: active === 3 }"
          @click="changeType(3, 'CSHS')"
        >
          船司航司
        </span>
        <span
          v-permissson="'CM'"
          class="tabItem"
          :class="{ active: active === 4 }"
          @click="changeType(4, 'CM')"
        >
          船名
        </span>
      </div>
      <div class="optheader">
        <div v-if="active < 4" class="search">
          <el-input
            v-model="searchVal"
            :placeholder="`${(active !== 2 && active !== 3 )? '请输入公司名称' : '请输入代码'}`"
            class="input-search"
            @keydown.enter.native="search"
          ></el-input>
          <div class="btn-search" @click="search">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <el-select
          v-if="active === 1"
          v-model="types"
          style="width: 200px"
          filterable
          clearable
          placeholder="请选择信息类型"
          size="mini"
          @change="getSicnList(pager)"
        >
          <el-option
            v-for="item in sicnOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div v-if="active === 0" class="type-tab">
          <span
            :class="[typeActive === -1 && 'active']"
            @click="handleTypeChange(-1)"
          >全部</span
          >
          <span
            :class="[typeActive === 0 && 'active']"
            @click="handleTypeChange(0)"
          >私仓</span
          >
          <span
            :class="[typeActive === 1 && 'active']"
            @click="handleTypeChange(1)"
          >亚马逊仓</span
          >
          <span
            :class="[typeActive === 100 && 'active']"
            @click="handleTypeChange(100)"
          >沃尔玛仓</span
          >
          <!-- <span
            :class="[typeActive === 103 && 'active']"
            @click="handleTypeChange(103)"
          >自营</span
          > -->
        </div>
        <div
          v-show="newAdd"
          :v-permissson="newAdd"
          class="add flex_c_c"
          @click="add"
        >
          <svg-icon className="icon" iconClass="add" />新增
        </div>
        <div
          v-show="exportFile"
          :v-permissson="exportFile"
          class="add flex_c_c"
          @click="downloadFile"
        >
          <i class="el-icon-download" />
          导出
        </div>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
          columns
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
      >
        <template slot="isActived" slot-scope="row">
          <div
            :class="[
              'flex_c_c',
              'isActived',
              row.scope.isActived ? 'isActived1' : 'isActived2',
            ]"
          >
            {{ row.scope.isActived ? "启用" : "停用" }}
          </div>
        </template>
        <template slot="type" slot-scope="row">
          <div
            :class="[
              'warehouseType',
              `warehouseType${row.scope.type}`,
              'flex_c_c',
            ]"
          >
            {{ row.scope.type | formatWarehouseType }}
          </div>
        </template>
        <template slot="attentionName" slot-scope="row">
          <div class="infobox">
            <el-row style="display: flex">
              <div class="infoItem" style="min-width: 145px">
                <span class="label label1">公司</span>
                <span class="num">{{ row.scope.companyName }}</span>
              </div>

              <div class="infoItem">
                <span class="label label1">联系人</span>
                <span class="num">{{ row.scope.contact || row.scope.attentionName }}</span>
              </div>
            </el-row>
            <el-row style="display: flex">
              <div class="infoItem">
                <span class="label label1">电话</span>
                <span class="num">{{ row.scope.phoneNumber }}</span>
              </div>
              <div class="infoItem">
                <span class="label label1">邮箱</span>
                <span class="num">{{ row.scope.email }}</span>
              </div>
            </el-row>
          </div>
        </template>
        <template slot="countryName" slot-scope="row">
          <div class="infobox">
            <el-row style="display: flex">
              <div class="infoItem">
                <span class="label label1">国家</span>
                <span class="num">{{ row.scope.countryName || row.scope.countryCode }}</span>
              </div>
              <div class="infoItem">
                <span class="label label4">省州</span>
                <span class="num">{{ row.scope.provinceEnName || row.scope.provinceName || row.scope.state }}</span>
              </div>
              <div class="infoItem">
                <span class="label label4">城市</span>
                <span class="num">{{ row.scope.cityAddress || row.scope.city }}</span>
              </div>
              <div class="infoItem">
                <span class="label label4">邮编</span>
                <span class="num">{{ row.scope.postalCode || row.scope.postcode }}</span>
              </div>
            </el-row>
            <el-row v-if="row.scope.address">
              <div class="infoItem">
                <span class="label label1">地址</span>
                <span class="num">{{ row.scope.address }}</span>
              </div>
            </el-row>
            <!-- <el-row v-if="row.scope.addressLine3">
              <div class="infoItem">
                <span class="label label1">地址三</span>
                <span class="num">{{ row.scope.addressLine3 }}</span>
              </div>
            </el-row> -->
          </div>
        </template>
        <template slot="typeNames" slot-scope="row">
          <el-tag v-for="(item, $index) in row.scope.typeNames" :key="$index">
            {{ item }}
          </el-tag>
        </template>
        <template slot="opt" slot-scope="row">

          <el-popover
            v-if="active !== 4"
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-permissson="'update'"
                  class="opt-item"
                  @click="updateWarehouse(row.scope)"
                >修改</el-button
                >
                <el-button
                  class="opt-item"
                  @click="deleteWarehouse(row.scope)"
                >删除</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
        <template slot="companyName" slot-scope="row">
          {{ row.scope.companyName }}
          <!-- <span class="tips" :class="!row.scope.permission ? 'tips-owner': 'tips-out'">
            {{ !row.scope.permission ? '内部' : '外部' }}
          </span> -->
        </template>
        <template slot="name" slot-scope="row">
          {{ row.scope.name }}
        </template>
      </BaseTable>
    </div>
    <WarehouseDialog
      :dialogVisible="dialogVisible"
      :editData="editData"
      @ok="ok"
      @cancel="cancel"
    ></WarehouseDialog>
    <WarehouseAddDialog
      :dialogVisible="dialogVisible1"
      :editData="editData1"
      :activeName="activeName"
      :isSelectType="isSelectType"
      @ok="ok"
      @cancel="cancel"
    ></WarehouseAddDialog>
    <AddHarborDialog
      :dialogVisible="dialogVisible5"
      :editData="editData1"
      @ok="ok"
      @cancel="cancel"
    >
    </AddHarborDialog>
    <AddLineDialog
      :dialogVisible="dialogVisible6"
      :editData="editData1"
      @ok="ok"
      @cancel="cancel"
    >
    </AddLineDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const WarehouseDialog = () => import('@/components/dialog/WarehouseDialog.vue')
const WarehouseAddDialog = () =>
  import('@/components/dialog/WarehouseAddDialog.vue')
// import config from '@/utils/config'
import AddHarborDialog from './components/AddHarborDialog.vue'
import AddLineDialog from './components/AddLineDialog.vue'
import { permissions, derive } from '@/utils/common'
import {
  // getImporterPages,
  // defaultAddressBook,
  getAddressBookPages,
  deleteScin,
  deleteAddressBook,
  deleteTransport,
  deleteHarbor,
  // openSearchAddressBooks,
  // openDeleteAddressBook,
  getScinPageList,
  getHarborPageList,
  getTransportPageList,
  addVesselName,
  getVesselNameList
} from '@/api/basic'
// import { GetImporterStatistics } from '@/api/bill'
import { myMixins } from '@/mixins'
import { mapGetters } from 'vuex'
export default {
  name: 'BaseData',
  components: {
    BaseTable,
    WarehouseDialog,
    WarehouseAddDialog,
    AddHarborDialog,
    AddLineDialog
  },
  filters: {
    formatWarehouseType(v) {
      const obj = {
        0: '私仓',
        1: '亚马逊仓',
        100: '沃尔玛仓',
        103: '自营'
      }
      return obj[v]
    }
  },
  mixins: [myMixins],
  data() {
    return {
      types: '',
      sicnOptions: [
        {
          value: 0,
          label: 'Shipper(发货人)'
        },
        {
          value: 1,
          label: 'Consignee(收货人)'
        },
        // {
        //   value: 2,
        //   label: 'Importer(进口商)'
        // },
        {
          value: 3,
          label: 'Notify Party(通知方)'
        },
        {
          value: 4,
          label: 'Manufacturer(制造商)'
        },
        {
          value: 5,
          label: 'Ultimate Consignee(最终收货人)'
        },
        {
          value: 6,
          label: 'Buyer(买方)'
        },
        {
          value: 7,
          label: 'Seller(卖方)'
        },
        {
          value: 8,
          label: 'Ship To Party(到货方)'
        },
        {
          value: 9,
          label: 'Consolidator(集拼方)'
        },
        {
          value: 10,
          label: 'Stuffing(装箱方)'
        }
      ],
      activeName: '0',
      tableData: {
        columns: [],
        total: 0
      },
      loading: false,
      height: 0,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      dialogVisible: false,
      editData: {},
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      editData1: {},
      addressBookId: 0,
      title: '新增-私仓',
      searchVal: '',
      active: 1,
      activeCode: '',
      typeActive: -1,
      companyId: '',
      isSelectType: false,
      sortable: {}
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown', 'addressDropOption']),
    newAdd() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH.includes('新增'))?.code
      return code || 'add'
    },
    exportFile() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH.includes('导出'))?.code
      return code || ''
    },
    fileds() {
      const obj = {
        0: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'code',
            label: '仓库代码',
            width: '120'
          },
          {
            filed: 'type',
            label: '仓库类型',
            width: '200',
            align: 'center',
            isCustom: true
          },
          {
            filed: 'companyId',
            label: '客户',
            width: '160',
            formatter: (row) => {
              if (row.companyId && row.companyId !== '0') {
                const item = this.companyDrapdown.find(
                  (a) => a.value === row.companyId
                )
                return `外部-${item?.label}`
              } else {
                return '内部'
              }
            }
          },
          {
            filed: 'attentionName',
            label: '联系信息',
            width: '500',
            isCustom: true
          },
          {
            filed: 'countryName',
            label: '地址信息',
            width: '700',
            isCustom: true
          }
        ],
        1: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'name',
            label: '抬头名称',
            width: '180',
            align: 'center',
            isCustom: true
          },
          {
            filed: 'attentionName',
            label: '联系信息',
            width: '400',
            isCustom: true
          },
          {
            filed: 'countryName',
            label: '地址信息',
            width: '500',
            isCustom: true
          },
          {
            filed: 'typeNames',
            label: '抬头类型',
            width: '300',
            isCustom: true
          },
          {
            filed: 'taxNo',
            label: 'EIN',
            width: '150'
          }
        ],
        2: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'portType',
            label: '类型',
            width: '80px',
            formatter: (row) => (row.portType ? '海运' : '空运')
          },
          {
            filed: 'typeNames',
            label: '港口类型',
            width: ''
          },
          {
            filed: 'code',
            label: '代码',
            width: ''
          },
          {
            filed: 'nameCH',
            label: '中文名称',
            width: ''
          },
          {
            filed: 'nameEN',
            label: '英文名称',
            width: ''
          },
          {
            filed: 'countryId',
            label: '国家',
            width: '',
            formatter: (row) => {
              const item = this.addressDropOption.find(
                (a) => +a.value === +row.countryId
              )
              return item?.label
            }
          },
          {
            filed: 'provinceId',
            label: '省份',
            width: '',
            formatter: (row) => {
              const item = this.addressDropOption.find(
                (a) => +a.value === +row.countryId
              )
              return item?.children.find(
                (a) => +a.value === +row.provinceId
              )?.label
            }
          }
          // {
          //   filed: 'city',
          //   label: '城市',
          //   width: ''
          //   // formatter: (row) => {
          //   //   const item = this.addressDropOption.find(
          //   //     (a) => +a.value === +row.countryId
          //   //   )
          //   //   const province = item?.children.find(
          //   //     (a) => +a.value === +row.provinceId
          //   //   )
          //   //   return province?.children.find(
          //   //     (a) => +a.value === +row.cityId
          //   //   )?.label
          //   // }
          // }
        ],
        3: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'type',
            label: '类型',
            width: '',
            formatter: (row) => (row.type ? '船司' : '航司')
          },
          {
            filed: 'code',
            label: '代码',
            width: ''
          },
          {
            filed: 'nameCH',
            label: '中文名称',
            width: ''
          },
          {
            filed: 'nameEN',
            label: '英文名称',
            width: ''
          },
          {
            filed: 'website',
            label: '网址',
            width: ''
          },
          {
            filed: 'remark',
            label: '备注',
            width: ''
          }
        ],
        4: [{
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'vesselName',
            label: '船名',
            width: ''
          }
        ]
      }
      return obj[this.active]
    },
    columns() {
      if (this.active === 4) {
        return this.tableData.columns.slice((this.pager.pageIndex - 1) * this.pager.pageSize, (this.pager.pageIndex) * this.pager.pageSize)
      } else {
        return this.tableData.columns
      }
    }
  },
  created() {
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeLits = ['CKXX', 'TTXX', 'MT', 'CSHS', 'CM']
    this.active = codeLits.indexOf(menu.children[0].code)
    this.activeCode = menu.children[0].code
    this.initList()
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    changeType(type, code) {
      this.active = type
      this.searchVal = ''
      this.activeCode = code
      this.tableData.columns = []
      this.tableData.total = 0
      const params = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = params
      if (type === 0) {
        this.activeName = '0'
        this.getCompanyWarehouse(params)
      } else if (type === 1) {
        this.activeName = '20'
        this.getSicnList(params)
      } else if (type === 2) {
        this.getHarborList(params)
      } else if (type === 3) {
        this.getLineList(params)
      } else if (type === 4) {
        this.getVesselList(params)
      }
    },
    addressTag(row) {
      let className = ''
      switch (row.classification) {
        // 0 = BUSINESS(商业), 1 = MIXED(混合), 2 = RESIDENTIAL(住宅), 3 = UNKNOWN(未知)
        case 0:
          className = 'address-tag-1'
          break
        case 1:
          className = ''
          break
        case 2:
          className = 'address-tag-0'
          break
        case 3:
          className = 'address-tag-2'
          break
      }
      return className
    },
    handlePageChange(pager) {
      this.pager = pager
      if (this.active === 0) {
        this.activeName = '0'
        this.getCompanyWarehouse(pager)
      } else if (this.active === 1) {
        this.activeName = '20'
        this.getSicnList(pager)
      } else if (this.active === 2) {
        this.getHarborList(pager)
      } else if (this.active === 3) {
        this.getLineList(pager)
      }
    },
    async getCompanyWarehouse(params) {
      this.loading = true
      params = {
        ...params,
        queryParam: {
          type: this.typeActive,
          search: this.searchVal || undefined,
          companyId: this.companyId || undefined
          // supplierId: config.supplyCode
        }
      }
      try {
        const res = await getAddressBookPages(params)
        if (res.success) {
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    async getSicnList(params) {
      params = {
        ...params,
        queryParam: {
          type: this.types || undefined,
          name: this.searchVal || undefined
        }
      }
      this.loading = true
      try {
        const res = await getScinPageList(params)
        if (res.success) {
          this.tableData.total = res.data.total
          this.tableData.columns = res.data.list
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async getHarborList(params) {
      params = {
        ...params,
        queryParam: {
          code: this.searchVal || undefined
        }
      }
      this.loading = true
      try {
        const res = await getHarborPageList(params)
        if (res.success) {
          this.tableData.total = res.data.total
          this.tableData.columns = res.data.list
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async getLineList(params) {
      params = {
        ...params,
        queryParam: {
          code: this.searchVal || undefined
        }
      }
      this.loading = true
      try {
        const res = await getTransportPageList(params)
        if (res.success) {
          this.tableData.total = res.data.total
          this.tableData.columns = res.data.list
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async getVesselList(params) {
      params = {
        ...params,
        queryParam: {}
      }
      this.loading = true
      try {
        const res = await getVesselNameList(params)
        if (res.success) {
          this.tableData.total = res.data.length
          this.tableData.columns = res.data
          this.loading = false
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      if (this.active === 0) {
        this.getCompanyWarehouse(param)
      } else if (this.active === 1) {
        this.getSicnList(param)
      } else if (this.active === 2) {
        this.getHarborList(param)
      } else if (this.active === 3) {
        this.getLineList(param)
      } else if (this.active === 4) {
        this.getVesselList(param)
      }
    },
    update(row) {
      this.editData1 = row
      this.dialogVisible1 = true
    },
    updateImporter(row) {
      this.editData1 = row
      this.dialogVisible3 = true
    },
    updateWarehouse(row) {
      switch (this.active) {
        case 0:
          this.isSelectType = false
          this.activeName = row.type
          this.dialogVisible1 = true
          this.editData1 = row
          break
        case 1:
          this.isSelectType = false
          this.activeName = '20'
          this.dialogVisible1 = true
          this.editData1 = row
          break
        case 2:
          this.dialogVisible5 = true
          this.editData1 = row
          break
        case 3:
          this.dialogVisible6 = true
          this.editData1 = row
          break
      }
    },
    deleteWarehouse(row) {
      let str = ''
      switch (this.active) {
        case 0:
          str = '删除仓库'
          break
        case 1:
          str = '删除抬头信息'
          break
        case 2:
          str = '删除码头'
          break
        case 3:
          str = '删除船司/航司'
          break
        case 4:
          str = '删除船名'
          break
      }
      this.$confirm(`是否${str}?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(async() => {
          try {
            let res
            switch (this.active) {
              case 0:
                res = await deleteAddressBook({ id: row.id })
                break
              case 1:
                res = await deleteScin({ id: row.id })
                break
              case 2:
                res = await deleteHarbor({ id: row.id })
                break
              case 3:
                res = await deleteTransport({ id: row.id })
                break
              // case 5: await openDeleteAddressBook({ id: row.id }); break
            }
            if (res.success) {
              this.initList()
              this.$message.success(res.errorMessage)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    uploadData(row) {
      this.editData1 = row
      this.dialogVisible4 = true
    },
    addresscheck(row) {
      console.log(row)
      this.editData = row
      this.dialogVisible = true
    },
    add() {
      switch (this.active) {
        case 0:
          this.isSelectType = true
          this.dialogVisible1 = true
          break
        case 1:
          this.isSelectType = false
          this.dialogVisible1 = true
          break
        case 2:
          this.dialogVisible5 = true
          break
        case 3:
          this.dialogVisible6 = true
          break
        case 4:
          this.$prompt('请输入船名', '船名', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValidator: function(val) {
              if (!val) {
                return '船名不能为空'
              }
            }
          })
            .then(({ value }) => {
              addVesselName({
                vesselName: value
              }).then((res) => {
                if (res.success) {
                  this.initList()
                } else {
                  this.$message.error(res.errorMessage)
                }
              })
            })
            .catch(() => {})
          break
      }
    },
    ok() {
      this.dialogVisible = false
      this.dialogVisible3 = false
      this.dialogVisible1 = false
      this.dialogVisible5 = false
      this.dialogVisible6 = false
      this.editData1 = {}
      this.editData = {}
      this.initList()
    },
    cancel() {
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.dialogVisible5 = false
      this.dialogVisible6 = false
      this.isSelectType = false
      this.editData = {}
      this.editData1 = {}
    },
    search() {
      this.initList()
    },
    handleTypeChange(value) {
      if (value === this.typeActive) return
      this.typeActive = value
      this.initList()
    },
    async downloadFile() {
      this.loading = true
      if (this.active === 1) {
        await derive('Scin/exportScin', 'post', {
          type: this.types || undefined,
          name: this.searchVal || undefined
        })
      }
      if (this.active === 2) {
        await derive('harbor/exportHarbor', 'post', {
          code: this.searchVal || undefined
        })
      }
      if (this.active === 3) {
        await derive('transport/exportTransport', 'post', {
          code: this.searchVal || undefined
        })
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: auto;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
  &:deep(.el-tag) {
    margin-left: 4px;
  }
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color:  rgb(18,88,188);
    }
    .type-tab {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      border-radius: 2px 2px 2px 2px;
      overflow: hidden;
      & > span {
        height: 30px;
        padding: 7px 12px;
        box-sizing: border-box;
        background: #f7f7f7;
        cursor: pointer;
        &.active {
          color: #ffffff;
          background:  rgb(18,88,188);
        }
      }
    }
  }
}
.data {
  width: 100%;
  height: calc(100% - 50px);
  z-index: 1;
  & .fTable {
    border-top: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  & .infobox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: auto;
    & .el-row + .el-row {
      margin-top: 4px;
    }
  }
  & .infoItem {
    display: flex;
    .label {
      display: flex;
      height: 24px;
      background: rgba(35, 149, 243, 0.15);
      border-radius: 2px 2px 2px 2px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      box-sizing: border-box;
    }
    .label1 {
      align-items: center;
      width: 50px;
      padding: 0 7px;
    }
    .label2 {
      justify-content: center;
      align-items: center;
      width: 60px;
    }
    .label3 {
      justify-content: center;
      align-items: center;
      width: 48px;
    }
    .label4 {
      justify-content: center;
      align-items: center;
      width: 40px;
    }
    .num {
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #77879e;
      margin-left: 4px;
    }
    & + .infoItem {
      margin-left: 20px;
    }
  }
  & .isActived {
    width: 40px;
    height: 26px;
    border-radius: 4px 4px 4px 4px;
    margin: 0 auto;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
  }
  & .isActived1 {
    background: rgba(53, 186, 131, 0.1);
    color: #35ba83;
  }
  & .isActived2 {
    background: rgba(254, 69, 61, 0.1);
    color: #fe453d;
  }
  & .level {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      cursor: pointer;
    }
  }
  & .level_green {
    color: #35ba83;
  }
  & .level_red {
    color: #fe453d;
  }
  &:deep(.el-popover__reference-wrapper) {
    display: flex;
    align-items: center;
  }
  .optdiv {
    .el-button {
      padding: 2.5px 0;
    }
  }
  .warehouseType {
    width: 60px;
    height: 26px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    margin: 0 auto;
    border-radius: 2px;
  }
  .warehouseType0 {
    color:  rgb(18,88,188);
    background: rgba(35, 149, 243, 0.1);
  }
  .warehouseType1 {
    color: rgba(53, 186, 131, 1);
    background: rgba(53, 186, 131, 0.1);
  }
  .warehouseType100 {
    color: rgba(157, 103, 254, 1);
    background: rgba(157, 103, 254, 0.1);
  }
  .warehouseType103 {
    color: rgba(255, 116, 68, 1);
    background: rgba(255, 116, 68, 0.1);
  }
}
.optheader {
  display: flex;
  & > div + div {
    margin-left: 8px;
  }
  .search {
    position: relative;
    display: flex;
    width: 200px;
    .input-search {
      width: 170px;
      height: 30px !important;
      /deep/ .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #dbe4f2;
      border-left: 0;
      border-radius: 0 4px 4px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  /deep/ .el-input__inner {
    height: 30px;
  }
  .add {
    width: 84px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
    line-height: 24px;
    .icon {
      font-size: 20px;
    }
  }
  .filter {
    width: 84px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid  rgb(18,88,188);
    border-color: rgba(35, 149, 243, 0.4);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    cursor: pointer;
    line-height: 24px;
  }
}
.opbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  .NObtn {
    width: 84px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #feaa4f;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #feaa4f;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
  .Yesbtn {
    width: 84px;
    height: 32px;
    background: #35ba83;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    margin-right: 16px;
    cursor: pointer;
  }
}
.opt {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.address-tag {
  width: auto;
  height: 24px;
  display: inline-block;
  border-radius: 4px 4px 4px 4px;
  padding: 0 8px;
  box-sizing: border-box;
  & + .address-tag {
    margin-top: 4px;
  }
}
.address-detail {
  width: auto;
  height: 48px;
  font-size: 14px;
  font-weight: Regular;
  color: #25396f;
  line-height: 24px;
  text-indent: 4px;
  text-align: left;
}
.address-tag-0 {
  background: rgba(53, 186, 131, 0.1);
  color: rgba(53, 186, 131, 1);
}
.address-tag-1 {
  background: rgba(35, 149, 243, 0.1);
  color: rgba(35, 149, 243, 1);
}
.address-tag-3 {
  background: rgba(157, 103, 254, 0.1);
  color: rgba(157, 103, 254, 1);
}
.address-tag-2 {
  background: rgba(254, 69, 61, 0.1);
  color: rgba(254, 69, 61, 1);
}
.tips {
  position: absolute;
  display: inline-block;
  width: auto;
  height: 20px;
  padding: 0 10px;
  font-size: 12px;
  line-height: 20px;
  top: 0;
  left: 0;
}
.tips-owner {
  color: rgba(53, 186, 131, 1);
  background: rgba(53, 186, 131, .1);
}
.tips-out {
  color: rgba(254, 69, 61, 1);
  background: rgba(254, 69, 61, .1);
}
.tag {
  width: 100%;
  height: 64px;
}
/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-top: none;
}
/deep/ .el-tabs__item {
  height: 24px;
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  line-height: normal;
  color: #7c8db5;
}
/deep/ .el-tabs__item.is-active {
  color: #409eff !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav:first-child {
  border-left: none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav:last-child {
  border-right: none;
}
</style>
<style lang="less">
.level_tabel {
  width: 100%;
  height: 200px;
  border-radius: 4px 4px 4px 4px;
  overflow: hidden;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  .level_tabel-header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    background: #f7f7f7;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    & span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 100%;
      & + span {
        border-left: 1px solid #eeeeee;
        box-sizing: border-box;
      }
    }
  }
  .level_tabel-body {
    width: 100%;
    height: calc(100% - 40px);
    & li {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border-bottom: 1px solid #eeeeee;
      box-sizing: border-box;
      & span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 100%;
        & + span {
          border-left: 1px solid #eeeeee;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
